/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');


/*
 * Load DataTables
 */
require('datatables.net-rowgroup-dt');
require('datatables.net-bs4');
require('datatables.net-fixedcolumns');

require('./includes/datetimepicker');
require('./includes/form-handlers');


/*
 * Load VueJS
 */
import Vue from 'vue'


import Select2MultipleControl from 'v-select2-multiple-component';
import Select2Ajax from './components/Select2Ajax.vue';

// this demonstrate with buttons and responsive master/details row
import VdtnetTable from 'vue-datatables-net/dist'

Vue.component('Select2MultipleControl', Select2MultipleControl);
Vue.component('select2ajax', Select2Ajax);

Vue.component('VdtnetTable', VdtnetTable);


Vue.component('fuel-lap-mutations-reviewal-table', require('./components/FuelLapMutations/FuelLapMutationsReviewalTable.vue').default);

Vue.component('fuel-discounts-mutations-new-filter', require('./components/FuelDiscountMutations/FuelDiscountMutationsNew/FuelDiscountMutationsNewFilter.vue').default);
Vue.component('fuel-discounts-mutations-new-table', require('./components/FuelDiscountMutations/FuelDiscountMutationsNew/FuelDiscountMutationsNewTable.vue').default);
Vue.component('fuel-discounts-mutations-new', require('./components/FuelDiscountMutations/FuelDiscountMutationsNew/FuelDiscountMutationsNew.vue').default);

Vue.component('fuel-discounts-mutations', require('./components/FuelDiscountMutations/FuelDiscountMutationsOverview/FuelDiscountMutations.vue').default);
Vue.component('fuel-discounts-mutations-filter', require('./components/FuelDiscountMutations/FuelDiscountMutationsOverview/FuelDiscountMutationsFilter.vue').default);
Vue.component('fuel-discounts-mutations-table', require('./components/FuelDiscountMutations/FuelDiscountMutationsOverview/FuelDiscountMutationsTable.vue').default);

Vue.component('fuel-discount-mutations-reviewal-table', require('./components/FuelDiscountMutations/FuelDiscountMutationsReviewal/FuelDiscountMutationsReviewalTable.vue').default);

Vue.component('tankcards-mutations', require('./components/TankCardMutations/TankCardMutationsOverview/TankCardMutations.vue').default);
Vue.component('tankcards-mutations-filter', require('./components/TankCardMutations/TankCardMutationsOverview/TankCardMutationsFilter.vue').default);
Vue.component('tankcards-mutations-table', require('./components/TankCardMutations/TankCardMutationsOverview/TankCardMutationsTable.vue').default);


Vue.component('tankcards-requests', require('./components/TankCardMutations/TankCardrequestsRequestsOverview/TankCardRequests.vue').default);
Vue.component('tankcards-requests-filter', require('./components/TankCardMutations/TankCardrequestsRequestsOverview/TankCardRequestsFilter.vue').default);
Vue.component('tankcards-requests-table', require('./components/TankCardMutations/TankCardrequestsRequestsOverview/TankCardRequestsTable.vue').default);

Vue.component('tankcard-form', require('./components/client/TankCard/TankCardForm.vue').default);
Vue.component('tankcard-option-switch', require('./components/client/TankCard/option-switch.vue').default);

Vue.component('tank-card-mutations-reviewal-table', require('./components/TankCardMutations/TankCardMutationsReviewal/TankCardMutationsReviewalTable.vue').default);
Vue.component('tank-card-requests-reviewal-table', require('./components/TankCardMutations/TankCardRequestsReviewal/TankCardRequestsReviewalTable.vue').default);

Vue.component('files-tank-card-usages', require('./components/TankCardUsages/Files/Overview.vue').default);
Vue.component('files-tank-card-usages-table', require('./components/TankCardUsages/Files/Table.vue').default);
Vue.component('files-tank-card-usages-upload', require('./components/TankCardUsages/Files/Upload.vue').default);

window.Vue = Vue;
